module.exports = __webpack_public_path__ + "static/media/icon-add.e485e8cb.svg";